<template>
	<el-popover ref="popover" placement="right" trigger="hover" @show="show(null)" @close="open=false">
		<div v-if="open">
			<div v-if="tableLoading" class="loading-container">
				<el-spinner size="large" color="#409EFF"></el-spinner>
			</div>
			<div v-else>
				<el-table v-if="tableData && tableData.length > 0" :data="tableData" height="200px" :key="search.country + '_' + search.keyword + '_' + search.brand">
					<el-table-column width="210px" align="center">
						<template slot="header">
							日期 <span class="emphasis-hint">({{tableData.length}})</span>
						</template>
						<template slot-scope="scope">{{  fomatTimeStr(scope.row.date) }}</template>
					</el-table-column>
					<el-table-column label="排名" width="50px" align="center">
						<template slot-scope="scope">
							{{ (scope.row.clicked_brand.find(i => i.brand === search.brand) || {}).rank }}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<slot slot="reference">
			<span>{{ search.brand || search.asin }}</span>
		</slot>
	</el-popover>
</template>

<script>
import { api_getAsinTrendByKeyword_public } from "@/components/api/keywordReverseSearch";
import { toPercent } from "@/components/common/utils/fomatNum";
import { fomatTimeStr } from "@/components/common/utils/time";

export default {
	name: "brandTableSub",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			tableLoading : false,
			tableData : [],
			// tableDataLength : 0,
			search : {
				keyword : null,
				brand : null,
				country : null
			},
			open : false
		};
	},
	props : {
		searchP : {
			required: false
		}
	},
	created() {
			this.$data.search.keyword = this.searchP.keyword
			this.$data.search.brand = this.searchP.brand
			this.$data.search.country = this.searchP.country
	},
	computed: {
		tableDataLength() {
			return this.tableData.length;
		}
	},
	methods: {
		show : function(this_) {
			this_ = this_ || this
			// console.log(this.search);
			this_.$data.open = true
			if (this_.$data.tableData && this_.$data.tableData.length > 0) {
				// console.log('已经加载过数据，不再重复加载')
				return
			}
			// console.log('加载数据')
			let pa = { ...this_.$data.search }
			// console.info(pa)
			this_.$data.tableLoading = true
			api_getAsinTrendByKeyword_public(pa).then(res => {
				this_.$data.tableData = res.data
				// this_.$data.tableDataLength = res.data.length
				// 关闭遮罩
				this_.$data.tableLoading = false				
			}).catch(err => {
				// 关闭遮罩
				this_.$data.tableLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请重新尝试'), 4)
			})
		},
		toPercent : function(val) {
			return toPercent(val)
		},
		fomatTimeStr : function(time) {
			return fomatTimeStr(time)
		},
	}, watch: {
		// searchP: {
		// 	handler() {
		// 		this.$data.tableData = []
		// 	},
		// 	deep: true
		// },
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 200px; /* 调整容器高度以匹配表格高度 */
}
</style>